<div *ngIf="isOpen" (click)="onClose()"
    class="fixed inset-0 z-[60] w-full h-full flex items-center justify-center bg-slate-900/40 backdrop-blur-sm p-4">
    <div (click)="$event.stopPropagation()"
        class="relative bg-white rounded-2xl shadow-2xl w-full max-w-2xl max-h-[90vh] flex flex-col overflow-hidden animate-slide-up">
        <!-- Header -->
        <div class="flex items-center justify-between px-7 py-5 bg-white border-b border-slate-100 shrink-0">
            <div class="flex items-center gap-4">
                <div
                    class="w-10 h-10 rounded-[14px] bg-gradient-to-br from-primary to-primary-hover flex items-center justify-center shadow-lg shadow-primary/30">
                    <i class="pi pi-building text-white text-base"></i>
                </div>
                <div>
                    <h3 class="text-lg font-black text-slate-800 tracking-tight leading-none mb-0.5">
                        {{ (healthPlan ? 'modal_health_plan_title_edit' : 'modal_health_plan_title_add') | translate }}
                    </h3>
                    <span class="text-[10px] text-slate-400 font-bold uppercase tracking-[0.12em]">{{
                        'modal_health_plan_subtitle' | translate }}</span>
                </div>
            </div>
            <button type="button" (click)="onClose()"
                class="w-9 h-9 rounded-xl flex items-center justify-center text-slate-300 hover:text-slate-600 hover:bg-slate-100 transition-all">
                <i class="pi pi-times text-sm"></i>
            </button>
        </div>

        <!-- Body -->
        <div class="p-7 overflow-y-auto flex-1 space-y-6 no-scrollbar">
            <form [formGroup]="form" class="space-y-8">

                <!-- Name and Phone -->
                <div class="grid grid-cols-2 gap-6">
                    <div>
                        <label class="block text-[10px] font-black text-slate-400 uppercase tracking-widest mb-1.5">{{
                            'field_name' | translate }} <span class="text-red-500">*</span></label>
                        <input type="text" formControlName="name"
                            class="w-full px-4 py-3 bg-slate-50 border border-slate-200 rounded-xl text-sm focus:ring-4 focus:ring-primary/10 focus:border-primary outline-none transition-all shadow-sm"
                            [ngClass]="{'border-red-500': form.get('name')?.invalid && form.get('name')?.touched}"
                            placeholder="{{ 'placeholder_name' | translate }}">
                    </div>
                    <div>
                        <label class="block text-[10px] font-black text-slate-400 uppercase tracking-widest mb-1.5">{{
                            'field_phone' | translate }}</label>
                        <app-phone-input formControlName="cell_phone"></app-phone-input>
                    </div>
                </div>

                <!-- Email and NIPC -->
                <div class="grid grid-cols-2 gap-6">
                    <div>
                        <label class="block text-[10px] font-black text-slate-400 uppercase tracking-widest mb-1.5">{{
                            'field_email' | translate }} <span class="text-red-500">*</span></label>
                        <input type="email" formControlName="email"
                            class="w-full px-4 py-3 bg-slate-50 border border-slate-200 rounded-xl text-sm focus:ring-4 focus:ring-primary/10 focus:border-primary outline-none transition-all shadow-sm"
                            [ngClass]="{'border-red-500': form.get('email')?.invalid && form.get('email')?.touched}"
                            placeholder="{{ 'placeholder_email' | translate }}">
                    </div>
                    <div>
                        <label class="block text-[10px] font-black text-slate-400 uppercase tracking-widest mb-1.5">{{
                            'field_nipc' | translate }} <span class="text-red-500">*</span></label>
                        <input type="text" formControlName="nipc"
                            class="w-full px-4 py-3 bg-slate-50 border border-slate-200 rounded-xl text-sm focus:ring-4 focus:ring-primary/10 focus:border-primary outline-none transition-all shadow-sm"
                            [ngClass]="{'border-red-500': form.get('nipc')?.invalid && form.get('nipc')?.touched}"
                            placeholder="{{ 'placeholder_nipc' | translate }}">
                    </div>
                </div>

                <div class="border-t border-slate-100"></div>

                <!-- Country and Zip -->
                <div class="grid grid-cols-2 gap-6">
                    <div>
                        <label class="block text-[10px] font-black text-slate-400 uppercase tracking-widest mb-1.5">{{
                            'field_country' | translate }}</label>
                        <select formControlName="country"
                            class="w-full px-4 py-3 bg-slate-50 border border-slate-200 rounded-xl text-sm focus:ring-4 focus:ring-primary/10 focus:border-primary outline-none transition-all shadow-sm appearance-none cursor-pointer">
                            <option *ngFor="let c of countries" [value]="c.code">{{ c.name | translate }}</option>
                        </select>
                    </div>
                    <div>
                        <label class="block text-[10px] font-black text-slate-400 uppercase tracking-widest mb-1.5">{{
                            'field_postal_code' | translate }} <span class="text-red-500">*</span></label>
                        <p-inputMask formControlName="postal_code" mask="9999-999"
                            [styleClass]="'w-full px-4 py-3 bg-slate-50 border rounded-xl text-sm focus:ring-4 focus:ring-primary/10 focus:border-primary outline-none transition-all shadow-sm ' + (form.get('postal_code')?.invalid && form.get('postal_code')?.touched ? 'border-red-500' : 'border-slate-200')"
                            placeholder="{{ 'placeholder_postal_code' | translate }}">
                        </p-inputMask>
                    </div>
                </div>

                <!-- Address and Number -->
                <div class="flex gap-6">
                    <div class="flex-grow">
                        <label class="block text-[10px] font-black text-slate-400 uppercase tracking-widest mb-1.5">{{
                            'field_address' | translate }} <span class="text-red-500">*</span></label>
                        <input type="text" formControlName="address"
                            class="w-full px-4 py-3 bg-slate-50 border border-slate-200 rounded-xl text-sm focus:ring-4 focus:ring-primary/10 focus:border-primary outline-none transition-all shadow-sm"
                            [ngClass]="{'border-red-500': form.get('address')?.invalid && form.get('address')?.touched}"
                            placeholder="{{ 'placeholder_address' | translate }}">
                    </div>
                    <div class="w-32">
                        <label class="block text-[10px] font-black text-slate-400 uppercase tracking-widest mb-1.5">{{
                            'field_number' | translate }} <span class="text-red-500">*</span></label>
                        <input type="text" formControlName="address_number"
                            class="w-full px-4 py-3 bg-slate-50 border border-slate-200 rounded-xl text-sm focus:ring-4 focus:ring-primary/10 focus:border-primary outline-none transition-all shadow-sm"
                            [ngClass]="{'border-red-500': form.get('address_number')?.invalid && form.get('address_number')?.touched}"
                            placeholder="{{ 'placeholder_number' | translate }}">
                    </div>
                </div>

                <!-- Complemento -->
                <div>
                    <label class="block text-[10px] font-black text-slate-400 uppercase tracking-widest mb-1.5">{{
                        'field_complement' | translate }}</label>
                    <input type="text" formControlName="address_complement"
                        class="w-full px-4 py-3 bg-slate-50 border border-slate-200 rounded-xl text-sm focus:ring-4 focus:ring-primary/10 focus:border-primary outline-none transition-all shadow-sm"
                        placeholder="{{ 'placeholder_complement' | translate }}">
                </div>

                <!-- Bairro/Cidade -->
                <div class="grid grid-cols-2 gap-6">
                    <div>
                        <label class="block text-[10px] font-black text-slate-400 uppercase tracking-widest mb-1.5">{{
                            'field_neighborhood' | translate }} <span class="text-red-500">*</span></label>
                        <input type="text" formControlName="neighborhood"
                            class="w-full px-4 py-3 bg-slate-50 border border-slate-200 rounded-xl text-sm focus:ring-4 focus:ring-primary/10 focus:border-primary outline-none transition-all shadow-sm"
                            [ngClass]="{'border-red-500': form.get('neighborhood')?.invalid && form.get('neighborhood')?.touched}"
                            placeholder="{{ 'placeholder_neighborhood' | translate }}">
                    </div>
                    <div>
                        <label class="block text-[10px] font-black text-slate-400 uppercase tracking-widest mb-1.5">{{
                            'field_city' | translate }} <span class="text-red-500">*</span></label>
                        <input type="text" formControlName="city"
                            class="w-full px-4 py-3 bg-slate-50 border border-slate-200 rounded-xl text-sm focus:ring-4 focus:ring-primary/10 focus:border-primary outline-none transition-all shadow-sm"
                            [ngClass]="{'border-red-500': form.get('city')?.invalid && form.get('city')?.touched}"
                            placeholder="{{ 'placeholder_city' | translate }}">
                    </div>
                </div>

                <!-- Estado -->
                <div>
                    <label class="block text-[10px] font-black text-slate-400 uppercase tracking-widest mb-1.5">{{
                        'field_state' | translate }} <span class="text-red-500">*</span></label>
                    <input type="text" formControlName="state"
                        class="w-full px-4 py-3 bg-slate-50 border border-slate-200 rounded-xl text-sm focus:ring-4 focus:ring-primary/10 focus:border-primary outline-none transition-all shadow-sm"
                        [ngClass]="{'border-red-500': form.get('state')?.invalid && form.get('state')?.touched}"
                        placeholder="{{ 'placeholder_state' | translate }}">
                </div>

            </form>
        </div>

        <!-- Footer -->
        <div class="px-7 py-4 border-t border-slate-100 bg-white flex items-center justify-end gap-3 shrink-0">
            <app-button [label]="'button_cancel' | translate" variant="ghost" (onClick)="onClose()"
                styleClass="!text-[10px] !font-bold !uppercase !tracking-widest !px-6 !py-2">
            </app-button>
            <app-button [label]="'button_save' | translate" [loading]="loading" [disabled]="form.invalid"
                (onClick)="onSubmit()"
                styleClass="!text-[10px] !font-black !uppercase !tracking-widest !px-10 !py-2.5 !rounded-xl !shadow-lg !shadow-primary/20">
            </app-button>
        </div>
    </div>
</div>

<style>
    .no-scrollbar::-webkit-scrollbar { display: none; }
    .no-scrollbar { -ms-overflow-style: none; scrollbar-width: none; }
</style>